import { useState } from "react";

import { FilterDefinitionType, FilterType } from "@/components/@types";
import { useFilterChipMutations } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";
import { Input } from "@/components/ui/input";

export function FilterChipValuePickerForNumber({
  filter,
  filterIndex,
  filterDefinition,
  onChange,
  setIsOpen,
}: {
  filter: FilterType;
  filterIndex: number;
  filterDefinition: FilterDefinitionType;
  onChange: any;
  setIsOpen: any;
}) {
  if (filter.type !== "number" && filter.type !== "currency") {
    return <></>;
  }

  const [value, setValue] = useState(filter.value);
  const { updateFilterAtIndex } = useFilterChipMutations();

  return (
    <Input
      value={value !== null && value !== undefined ? String(value) : ""}
      type="number"
      placeholder={`enter ${filterDefinition.type}...`}
      onChange={(e) => {
        const numValue = e.target.value === "" ? null : Number(e.target.value);
        setValue(numValue);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          // blur the input
          e.currentTarget.blur();
        }
      }}
      onBlur={() => {
        setIsOpen(false);
        updateFilterAtIndex(filterIndex, (current) => ({
          ...current,
          value,
        }));
      }}
      data-testid={`filter-value-input-${filterDefinition.name}`}
    />
  );
}
